<div class="overlay-inner-wrapper">
  @if (!isInspektion()) {
    <header class="header-2">
      <div class="branding">
        <span class="title">{{ 'Bauwerke verwalten' | mrTranslate }}</span>
      </div>
      <div class="header-actions">
        <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
          <cds-icon shape="times"/>
        </a>
      </div>
    </header>
  }

  <div
    id="bauwerksWrapper"
    class="w-100-p padding-10-lr padding-12-b scroll-y"
    [ngClass]="isInspektion() ? 'h-100' : 'h-60'">
    <div class="clr-row nxm clr-justify-content-end">
      <div class="clr-col-auto margin-12-tb">
        <div class="btn-group btn-primary btn-icon">
          <button
            class="btn btn-icon btn-success"
            [title]="'Neu' | mrTranslate"
            (click)="addBauw()">
            <cds-icon shape="file" />
          </button>
          <button
            class="btn btn-icon btn-danger"
            [title]="'Löschen' | mrTranslate"
            [disabled]="!selectedBauw()"
            (click)="deleteTitelBauw()">
            <cds-icon shape="times" />
          </button>

          <button
            type="submit"
            form="bauwerke-form"
            class="btn btn-icon margin-12-l"
            [clrLoading]="saveState()"
            [title]="'Speichern' | mrTranslate">
            <cds-icon shape="floppy" />
          </button>
        </div>
      </div>
    </div>

    <!-- Top-Sektion - Felder zum eintragen -->
    <!-- <div class="clr-row nxm margin-18-t">
    </div> -->
    <form
      id="bauwerke-form"
      [formGroup]="formBauTop"
      (ngSubmit)="saveIfValid()"
      [clrLabelSize]="12"
      clrForm
      clrLayout="vertical"
      class="width100 float-buttons padding-12-lr margin--35-t">
      @if (formBauTop.errors?.['not-in-Direction']; as err) {
        <div class="clr-row nxm clr-col-12 clr-col-sm-10 clr-col-md-8 clr-col-lg-6">
          <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
            <clr-alert-item>
              <span class="alert-text">
                {{
                  'Der Startmeter kann nicht ' + (err.upwards ? 'größer' : 'kleiner') + ' als der Endmeter sein'
                    | mrTranslate
                }}
              </span>
            </clr-alert-item>
          </clr-alert>
        </div>
      }
      <div class="clr-row nxm">
        <div class="clr-col-md-2 clr-col-sm-4 clr-col-6" [class.clr-order-2]="drehung.isOn">
          <clr-input-container>
            <label>
              {{ (!drehung.isOn ? 'von' : 'bis') | mrTranslate }}
              <div class="btn-group btn-sm btn-icon btn-float">
                <button
                  class="btn"
                  type="button"
                  [title]="'Geoposition orten' | mrTranslate"
                  tabindex="-1"
                  (click)="findPositionAndAutofill('von')"
                  [disabled]="formBauTop.disabled"
                  [clrLoading]="geoState()">
                  <cds-icon shape="map-marker" />
                </button>
              </div>
            </label>
            <input
              type="number"
              clrInput
              name="von"
              formControlName="von"
              [value]="formBauTop.controls.von.value | drehung: drehung.summe"
              (change)="formBauTop.controls.von.setValue(drehungPipe.back($event.target.value, drehung.summe))"
              [step]="0.1" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
            @if (formBauTop.controls.von.errors?.min; as err) {
              <clr-control-error>
                {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                {{ err.min | drehung: drehung.summe }}
              </clr-control-error>
            }
            @if (formBauTop.controls.von.errors?.max; as err) {
              <clr-control-error>
                {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                {{ err.max | drehung: drehung.summe }}
              </clr-control-error>
            }
          </clr-input-container>
        </div>
        <div class="clr-col-md-2 clr-col-sm-4 clr-col-6" [class.clr-order-1]="drehung.isOn">
          <clr-input-container>
            <label>
              {{ (!drehung.isOn ? 'bis' : 'von') | mrTranslate }}
              <div class="btn-group btn-sm btn-icon btn-float">
                <button
                  class="btn"
                  type="button"
                  [title]="'Geoposition orten' | mrTranslate"
                  tabindex="-1"
                  (click)="findPositionAndAutofill('bis')"
                  [disabled]="formBauTop.disabled"
                  [clrLoading]="geoState()">
                  <cds-icon shape="map-marker" />
                </button>
              </div>
            </label>
            <input
              type="number"
              clrInput
              name="bis"
              formControlName="bis"
              [value]="formBauTop.controls.bis.value | drehung: drehung.summe"
              (change)="formBauTop.controls.bis.setValue(drehungPipe.back($event.target.value, drehung.summe))"
              [step]="0.1" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
            @if (formBauTop.controls.bis.errors?.min; as err) {
              <clr-control-error>
                {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                {{ err.min | drehung: drehung.summe }}
              </clr-control-error>
            }
            @if (formBauTop.controls.bis.errors?.max; as err) {
              <clr-control-error>
                {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                {{ err.max | drehung: drehung.summe }}
              </clr-control-error>
            }
          </clr-input-container>
        </div>
        <div class="clr-col-md-2 clr-col-sm-4 clr-col-6 clr-order-3">
          <clr-select-container>
            <label class="d-f row w-100-p">
              <span class="clr-col nxp ellipsis">
                {{ 'Bauwerksart' | titlecase | mrTranslate }}
              </span>
              <div class="btn-group btn-sm btn-icon btn-float">
                <button
                  class="btn"
                  type="button"
                  [title]="'Tabelle verwalten' | mrTranslate"
                  tabindex="-1"
                  (click)="isBaseModalOpen.set(true)">
                  <cds-icon shape="pencil" />
                </button>
              </div>
            </label>
            <select clrSelect name="art" formControlName="bauwerksart">
              @for (wert of artListe(); track $index) {
                <option [value]="wert">{{ wert | mrTranslate }}</option>
              }
            </select>
            <clr-control-error *clrIfError="'required'">
              {{ "Feld 'Bauwerksart' muss ausgefüllt werden!" | mrTranslate }}
            </clr-control-error>
          </clr-select-container>
        </div>
        <div class="clr-col-md-2 clr-col-sm-4 clr-col-6 clr-order-3">
          <clr-input-container>
            <label>{{ 'Bezeichnung' | mrTranslate }}</label>
            <input type="text" clrInput name="bezeichnung" formControlName="bezeichnung" />
          </clr-input-container>
        </div>
        <div class="clr-col-md-2 clr-col-sm-4 clr-col-6 clr-order-3">
          <clr-input-container>
            <label>{{ 'Lage' | mrTranslate }}</label>
            <input type="text" clrInput name="lage" formControlName="lage" />
          </clr-input-container>
        </div>
        <div class="clr-col-md-2 clr-col-sm-4 clr-col-6 clr-order-3">
          <clr-input-container>
            <label>{{ 'GPS' | mrTranslate }}</label>
            <input type="text" clrInput name="gps" formControlName="gpskoordinaten" />
          </clr-input-container>
        </div>
      </div>
    </form>
    @if (table()) {
      <clr-datagrid
        class="datagrid-compact dg-overflow-fix"
        style="max-height: calc(100svh - 400px)"
        [clrDgItemsIdentityFn]="row => row?.id"
        [clrDgRowSelection]="true"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedBauw()]"
        (clrDgSelectedChange)="selectedBauw.set($event[0])">
        <clr-dg-column
          [clrDgField]="!drehung.isOn ? 'von' : 'bis'"
          [clrDgSortOrder]="direction() * (drehung.isOn ? -1 : 1)">
          {{ 'Startmeter' | titlecase | mrTranslate }}
        </clr-dg-column>
        <clr-dg-column [clrDgField]="!drehung.isOn ? 'bis' : 'von'">
          {{ 'Endmeter' | titlecase | mrTranslate }}
        </clr-dg-column>

        @for (column of table().columns | array: 'filter' : exceptStartEnd; track column.id) {
          <clr-dg-column [clrDgField]="column.id">
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['b_parentid', 'bild'] }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }

        <clr-dg-row *clrDgItems="let row of table().rows" [clrDgItem]="row">
          <clr-dg-cell class="name-cell">
            {{ row[!drehung.isOn ? 'von' : 'bis'] | drehung: drehung.summe | tablePrettyPrint }}
          </clr-dg-cell>
          <clr-dg-cell class="name-cell">
            {{ row[!drehung.isOn ? 'bis' : 'von'] | drehung: drehung.summe | tablePrettyPrint }}
          </clr-dg-cell>
          @for (cell of table().columns | array: 'filter' : exceptStartEnd; track cell.id) {
            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
          }
        </clr-dg-row>
        <clr-dg-footer>{{ table().rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }

    <div class="clr-row nxm padding-24-b">
      <div class="clr-col-12">
        <app-preview-thumbnails
          [acceptTypes]="'image/*'"
          [maxAmount]="6"
          (deleteFile)="deleteFile($any($event))"
          [allowCameraVideo]="false" />
      </div>
    </div>
  </div>
</div>
<app-baseitems-wrapper
  [(isModalOpen)]="isBaseModalOpen"
  [route]="{ tabelle: 'SBAUW', title: 'Bauwerke' | mrTranslate }"
  (refreshList)="artListe.set($event)" />
